import ESContext from "../ESContext";
import AnalyticsUtil from "../graphs/AnalyticsUtil";
import {YAxisFormatTime} from "../graphs/GraphFormatting";
import {formatSeconds} from "../../common/TimeUtil";
import HighChartsGraph from "../graphs/HighChartsGraph";
import CachedGraphV2 from "../graphs/CachedGraphV2";
import OutlierUtil from "../OutlierUtil";
import StatisticsUtil from "../StatisticsUtil";

class SessionLength_Retention {
    static getUUID() {
        return "e863194e-d7ac-4092-a9ff-1751b85d0511";
    }

    static getProps() {
        return [
            {id:"title",name:"Title", type:"string"},
            {id:"group",name:"Group by", type:"string"},
            {id:"onlyPIL", name:"Per PIL", type:"boolean"},
            {id:"filterOutlier", name: "Filter Outlier", type:"boolean"},
            {id:"filter",name:"Filter", type:"filterTags"}
        ];
    }

    static getGraphSize() {
        return 1;
    }

    static getHeightRatio() {
        return "50%";
    }

    static calcSessionLengthRetention(_dauData, _userData, _props, _groupValue) {
        let dauData = _dauData;
        let userData = _userData;
        if (_props.group && _groupValue) {
            dauData = AnalyticsUtil.filterBy(_dauData, (_e) => _e[_props.group] === _groupValue);
            userData = AnalyticsUtil.filterBy(_userData, (_e) => _e[_props.group] === _groupValue);
        }
        let series = [];
        let dauPilData = AnalyticsUtil.addPil(dauData);
        if (_props.onlyPIL) {
            userData = AnalyticsUtil.addPil(userData);
        }
        for (let pil = 0; pil <= 28; pil++) {
            let filtered = [];
            if (_props.onlyPIL) {
                filtered = AnalyticsUtil.filterBy(dauPilData,(_e) => _e.pil === pil);
            } else {
                filtered = AnalyticsUtil.filterBy(dauPilData,(_e) => _e.pil >= 0 && _e.pil <= pil && _e.maxPil >= pil);
            }
            let userCount = 0;
            for (let i = 0; i < userData.length; i++) {
                const current = userData[i];
                if (_props.onlyPIL) {
                    if (current.pil === pil) {
                        userCount += current.dau;
                    }
                } else {
                    const maxPil = AnalyticsUtil.calcMaxPil(current.install_date);
                    if (maxPil >= pil) {
                        userCount += current.installs;
                    }
                }
            }
            if (_props.filterOutlier) {
                let userData = {};
                for (let i = 0; i < filtered.length; i++) {
                    const current = filtered[i];
                    if (!userData[current.user_id]) {
                        userData[current.user_id] = 0;
                    }
                    if (typeof current.duration === "number") {
                        userData[current.user_id] += current.duration;
                    }
                }
                let sessionLengths = [];
                for (let userId in userData) {
                    sessionLengths.push(userData[userId]);
                }
                while (sessionLengths.length < userCount) {
                    sessionLengths.push(0);
                }
                let outlierResult = OutlierUtil.filterOutlier(sessionLengths);
                let avg = StatisticsUtil.avg(outlierResult.cleaned);
                let outlierPercentage = outlierResult.outlier.length / (outlierResult.outlier.length + outlierResult.cleaned.length);
                const outlierText = "Outliers: "+outlierResult.outlier.length+"("+Math.round(outlierPercentage*10000)/100+"%)";
                if (sessionLengths.length > 10) {
                    series.push({name: _groupValue, x: pil, y: avg, text: formatSeconds(avg)+" ("+outlierResult.cleaned.length+" Users) "+outlierText});
                }
            } else {
                let sessionLength = 0;
                for(let i = 0; i < filtered.length; i++) {
                    if (typeof filtered[i].duration === "number") {
                        sessionLength += filtered[i].duration;
                    }
                }
                let normalized = sessionLength/userCount;
                if (userCount > 10) {
                    series.push({name: _groupValue, x: pil, y: normalized, text: formatSeconds(normalized)+" ("+userCount+" Users)"});
                }

            }
        }
        return {name: _groupValue, data: series};
    }

    static getGraphData(ctx, _props, _cb) {
        let filter = JSON.parse(JSON.stringify(_props.filter));
        if (_props.dateSelection) {
            filter.install_date = {from: _props.dateSelection.start, to: _props.dateSelection.end};
        }
        const grouping = ["install_date","day", _props.group];
        if (_props.filterOutlier === true) {
            grouping.push("user_id");
        }
        if (_props.onlyPIL) {
            ctx.sendAsync("users","session_duration_v4",["cardinality:user_id:dau"],["install_date","day", _props.group], filter);
        } else {
            ctx.sendAsync("users","user_v4",["cardinality:user_id:installs"],["install_date", _props.group], filter);
        }
        ctx.sendAsync("dau","session_duration_v4",["sum:duration:duration"],grouping, filter);
        return ctx.waitForCompletion((_err, _data) => {
            if (_err) {
                _cb(_err);
            } else {
                let userData = _data.users.result;
                let dauData = _data.dau.result;
                let groups = AnalyticsUtil.getDistinct(dauData, _props.group);
                let series = [];
                if (groups.length > 0) {
                    for(let i = 0; i < groups.length; i++) {
                        let data = SessionLength_Retention.calcSessionLengthRetention(dauData, userData, _props, groups[i]);
                        series.push(data);
                    }
                } else {
                    let data = SessionLength_Retention.calcSessionLengthRetention(dauData, userData, _props);
                    series.push(data);
                }
                let graphData = {
                    chart : {type: "line"},
                    legend: {enabled: groups.length > 1},
                    series : series,
                };
                return _cb(null, graphData);
            }
        });
    }

    static getXAxis() {
        return {labels: {format: "D{value}"}, allowDecimals: false, crosshair: true};
    }

    static getYAxis() {
        return YAxisFormatTime();
    }

    static getTooltip() {
        return {
            split:true,
            formatter : function() {
                let result = ["D"+this.x];
                for(let i = 0; i < this.points.length; i++) {
                    result.push(this.points[i].point.text);
                }
                return result;
            }
        };
    }
}

export default CachedGraphV2(SessionLength_Retention, HighChartsGraph);